import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';

export const ContentStyled = styled(Stack)(() => ({}));

export const ItemStyled = styled(Stack)(() => ({
  overflowWrap: 'anywhere',
}));
